import React from "react";

export default function ResultsMetrics({title, metrics =[]}) {
  

  return (
    <section className="bg-white md:py-2 py-6 px-4 sm:px-8 text-center font-poppins">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold md:mb-10 pt-12">
        {title}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-10 font-bold gap-x-8 max-w-7xl mx-auto">
        {metrics.map((item, index) => (
          <div
            key={index}
            className="group bg-white rounded-xl md:p-6  transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-105 hover:bg-gradient-to-br hover:from-blue-50 hover:to-blue-100"
          >
            <div className="text-4xl sm:text-4xl font-poppins text-gray-900 group-hover:text-[#0F6CB4] transition-colors duration-300">
              {item.value}
            </div>
            <div className="text-sm sm:text-base text-gray-600 group-hover:text-[#0D283F] transition-colors duration-300">
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
